/**
 * @generated SignedSource<<4360f40c9edba68e6deb4588d6439b4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberSelectCompetitionFragment$data = {
  readonly textareaMembers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entity: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"MemberSelectEntityFragment">;
        };
      };
    }>;
  };
  readonly " $fragmentType": "MemberSelectCompetitionFragment";
};
export type MemberSelectCompetitionFragment$key = {
  readonly " $data"?: MemberSelectCompetitionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberSelectCompetitionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberSelectCompetitionFragment",
  "selections": [
    {
      "alias": "textareaMembers",
      "args": null,
      "concreteType": "CompetitionMembershipConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionMembershipEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompetitionMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "entity",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "MemberSelectEntityFragment"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Competition",
  "abstractKey": null
};

(node as any).hash = "9e2e4abf99c851e24b9c19f93e7e292f";

export default node;
